import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValidatorsModule } from '@gestor-web/app/shared/validators/validators.module';
import { BlendusPipesModule } from '@gestor-web/app/shared/pipes/pipes.module';
import { PrimengModule } from './primeng.module';

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  BlendusPipesModule,
  ValidatorsModule,
  PrimengModule,
];

@NgModule({
  exports: MODULES,
})
export class AppSharedModule {}
